export default function CreativeBuilderController(
  CreativeService,
  CreativeFormValidationService,
  CreativeGroupService,
  CurrentUserService,
  MixpanelService,
  SettingsService
) {
  const vm = this;
  SettingsService.showBuilderHeader = true;
  vm.activeIndex = 0;
  vm.addNewCreative = addNewCreative;
  vm.activateCreative = activateCreative;
  vm.creativeService = CreativeService;
  vm.creativeGroupService = CreativeGroupService;
  vm.validationService = CreativeFormValidationService;

  CurrentUserService.get().then(user => {
    vm.userSignedIn = !!user;
  });

  function activateCreative(creative, index) {
    // bail out if you're clicking somewhere on the currently-active panel; this
    // way we avoid unnecessary extra calls to `setCreative`
    if (vm.activeIndex === index) {
      return;
    }

    vm.activeIndex = index;

    CreativeService.setCreative(creative);
  }

  function addNewCreative() {
    let index = CreativeGroupService.group.creativePreviews.length;
    CreativeGroupService.addCreativeToList({
      action: CreativeService.creative.action
    });
    activateCreative(CreativeGroupService.group.creativePreviews[index], index);
    MixpanelService.track('Clicked New Creative Button (Adding to group)', {
      creativeCount: CreativeGroupService.group.creativePreviews.length
    });
  }

  return vm;
}

CreativeBuilderController.$inject = [
  'CreativeService',
  'CreativeFormValidationService',
  'CreativeGroupService',
  'CurrentUserService',
  'MixpanelService',
  'SettingsService'
];
